import { IonIcon } from '@ionic/react';
import { alertCircleOutline, arrowForward } from 'ionicons/icons';
import React from 'react';
import './OnboardingHomeBanner.css';

type OnboardingHomeBannerProps = {
    porcentagem: number;
    totalEtapas: number;
    etapasConcluidas: number;
    onClick: () => void;
};

const OnboardingHomeBanner: React.FC<OnboardingHomeBannerProps> = ({
    porcentagem,
    totalEtapas,
    etapasConcluidas,
    onClick
}) => {
    return (
        <div className="onboarding-home-banner" onClick={onClick}>
            <div className="onboarding-home-banner-content">
                <div className="onboarding-home-banner-text">
                    <div className="onboarding-home-banner-title">
                        <IonIcon icon={alertCircleOutline} /> Finalize o cadastro e abra sua loja agora!
                    </div>
                    <div className="onboarding-home-banner-progress">
                        Configuração inicial — {etapasConcluidas} de {totalEtapas} etapas concluídas
                    </div>
                </div>
                <IonIcon icon={arrowForward} className="onboarding-home-banner-arrow" />
            </div>
            <div className="onboarding-home-banner-bar">
                <div className="onboarding-home-banner-bar-fill" style={{ width: `${porcentagem}%` }} />
            </div>
        </div>
    );
};

export default OnboardingHomeBanner;